module.exports = __webpack_public_path__ + "img/wx.2c8ebd08.png";